export default __webpack_public_path__ + "static/media/space.47049ce0.png";